"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["action"];
const _hoisted_2 = { class: "flex-column flex-gap" };
const _hoisted_3 = { class: "flex-column flex-gap" };
const _hoisted_4 = {
    key: 0,
    type: "hidden",
    name: "SMSVerified",
    value: "1"
};
const _hoisted_5 = {
    key: 0,
    class: "flex-column flex-gap"
};
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'UserRegistrationForm',
    setup(__props, { expose: __expose }) {
        const viewModel = (0, vue_3.inject)(provider_1.registrationViewModelInjectKey);
        const userViewModel = (0, vue_3.inject)(provider_1.userRegistrationViewModelInjectKey);
        const userPresenter = (0, vue_3.inject)(provider_1.userRegistrationPresenterInjectKey);
        const formRef = (0, vue_3.ref)(null);
        const phoneClass = (0, vue_3.computed)(() => {
            return userViewModel?.value.form.phone ? 'readonly' : '';
        });
        const name = (0, vue_3.computed)({
            get: () => userViewModel?.value.form.name || '',
            set: (v) => userPresenter?.setField('name', v),
        });
        const furigana = (0, vue_3.computed)({
            get: () => userViewModel?.value.form.furigana || '',
            set: (v) => userPresenter?.setField('furigana', v),
        });
        const phone = (0, vue_3.computed)({
            get: () => userViewModel?.value.form.phone || '',
            set: (v) => userPresenter?.setField('phone', v),
        });
        const email = (0, vue_3.computed)({
            get: () => userViewModel?.value.form.email || '',
            set: (v) => userPresenter?.setField('email', v),
        });
        function onSubmit(e) {
            if (!userPresenter?.validate() || viewModel?.value.isOwner) {
                e.preventDefault();
            }
            userPresenter?.setIsLoading(false);
        }
        function submitForm() {
            if (!formRef.value) {
                userPresenter?.setIsLoading(false);
                return;
            }
            formRef.value.requestSubmit();
        }
        __expose({ submitForm });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                ref_key: "formRef",
                ref: formRef,
                method: "POST",
                action: (0, vue_2.unref)(viewModel)?.actionURL,
                onSubmit: onSubmit,
                class: "flex-column registration-form-container"
            }, [
                _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("div", { class: "registration-subtitle" }, "あなたについて教えてください。", -1 /* CACHED */)),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _cache[4] || (_cache[4] = (0, vue_2.createTextVNode)(" お名前 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event)),
                        name: "name",
                        class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(userViewModel)?.errors.name }]),
                        type: "text",
                        placeholder: "名前"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, name.value]
                    ]),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((furigana).value = $event)),
                        name: "furigana",
                        class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(userViewModel)?.errors.furigana }]),
                        type: "text",
                        placeholder: "ふりがな"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, furigana.value]
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    _cache[5] || (_cache[5] = (0, vue_2.createTextVNode)(" 電話番号 ", -1 /* CACHED */)),
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((phone).value = $event)),
                        name: "phone",
                        class: (0, vue_2.normalizeClass)(["form-input br-5", [{ 'input-error': (0, vue_2.unref)(userViewModel)?.errors.phone }, phoneClass.value]]),
                        type: "tel",
                        placeholder: "電話番号",
                        "data-com.agilebits.onepassword.user-edited": "yes"
                    }, null, 2 /* CLASS */), [
                        [vue_2.vModelText, phone.value]
                    ]),
                    (phone.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("input", _hoisted_4))
                        : (0, vue_2.createCommentVNode)("v-if", true)
                ]),
                ((0, vue_2.unref)(viewModel)?.branchId)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                        _cache[6] || (_cache[6] = (0, vue_2.createTextVNode)(" メールアドレス ", -1 /* CACHED */)),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((email).value = $event)),
                            name: "email",
                            class: (0, vue_2.normalizeClass)(["form-input br-5", { 'input-error': (0, vue_2.unref)(userViewModel)?.errors.email }]),
                            type: "email",
                            placeholder: "メールアドレス"
                        }, null, 2 /* CLASS */), [
                            [vue_2.vModelText, email.value]
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
